<template>
  <hic-list-page title="频率管理" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="名称或编码">
    <template slot="buttons">
      <el-button v-if="permission.masterdata_dict_create" type="primary" @click="create" size="small"> <i class="el-icon-plus"></i> 新建 </el-button>
    </template>
    <template slot="search">
      <el-select class="condition-wide" placeholder="请选择" clearable v-model="condition.frequencyType" size="small">
        <el-option label="西药" value="西药"></el-option>
        <el-option label="治疗" value="治疗"></el-option>
      </el-select>
    </template>

    <el-table-column label="名称" prop="name" width="150" key="text" sortable="custom">
      <template slot-scope="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="操作" width="200" align="center" key="action">
      <template slot-scope="scope">
        <el-button type="primary" icon="el-icon-edit" title="编辑" size="mini" @click="edit(scope.row)" circle plain />
        <!-- <el-button type="danger" icon="el-icon-close" title="删除" size="mini" @click="edit(scope.row)" circle /> -->
      </template>
    </el-table-column>
    <el-table-column label="编码" prop="code" min-width="100" align="center" key="code" sortable="custom" />
    <el-table-column label="助记码" prop="shortCode" min-width="100" align="center" key="shortCode" sortable="custom" />
    <el-table-column label="频率次数" prop="frequencyTimes" min-width="100" align="center" key="frequencyTimes" sortable="custom" />
    <el-table-column label="执行间隔(天)" prop="interval" min-width="150" align="center" key="interval" sortable="custom" />
    <el-table-column label="周期数量" prop="cycle" min-width="100" align="center" key="cycle" sortable="custom" />
    <el-table-column label="周期单位" prop="cycleUnit" min-width="100" align="center" key="cycleUnit" sortable="custom" />
    <el-table-column label="日时间点" prop="dailyTime" min-width="100" align="center" key="dailyTime" sortable="custom" />
    <el-table-column label="医联编码" prop="standardCode" min-width="100" align="center" key="standardCode" sortable="custom" />
    <el-table-column label="门诊" prop="forOp" min-width="100" align="center" key="forOp" sortable="custom">
      <template #default="{ row }">
        <el-tag v-if="row.forOp" type="success" hit size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="住院" prop="forIp" min-width="100" align="center" key="forIp" sortable="custom">
      <template #default="{ row }">
        <el-tag v-if="row.forIp" type="success" hit size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="药品" prop="forDrug" min-width="100" align="center" key="forDrug" sortable="custom">
      <template #default="{ row }">
        <el-tag v-if="row.forDrug" type="success" hit size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="草药" prop="forHerbal" min-width="100" align="center" key="forHerbal" sortable="custom">
      <template #default="{ row }">
        <el-tag v-if="row.forHerbal" type="success" hit size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="医技" prop="forMl" min-width="100" align="center" key="forMl" sortable="custom">
      <template #default="{ row }">
        <el-tag v-if="row.forMl" type="success" hit size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="排序" prop="seqNo" width="80" key="seqNo" sortable="custom" />
    <el-table-column label="备注" prop="memo" show-overflow-tooltip key="memo" />
    <frequency-editor v-if="showEditor" v-model="entity" :visible.sync="showEditor" @ok="entityUpdated" />
  </hic-list-page>
</template>

<script>
  import api from "./api";
  import store from "@/common/store";
  import { mapGetters } from "sw-hic";
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.masterdata_dict_query) {
        next({
          name: "err",
          params: { err: this.$cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    components: {
      "frequency-editor": () => import("./editor"),
    },
    data() {
      return {
        condition: {
          sort: "id",
          asc: false,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        meta: {
          loading: false,
        },
        searchLoading: false,
        entities: {},
        showEditor: false,
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["permission"]),
    },
    methods: {
      page() {
        let _this = this;
        this.meta.loading = true;
        api.Frequency.query(this.condition).then((res) => {
          _this.entities = res;
          _this.meta.loading = false;
        });
      },
      create() {
        this.$set(this, "entity", {
          code: null,
          name: null,
          forOp: true,
          forIp: true,
          forDrug: true,
          forHerbal: true,
          forMl: true,
          seqNo: null,
          memo: null,
          disabled: false,
        });
        this.showEditor = true;
      },
      edit(row) {
        this.$set(this, "entity", JSON.parse(JSON.stringify(row)));
        this.showEditor = true;
      },
      entityUpdated(value) {
        this.$store.dispatch("loadDicts", value.type);
        this.page();
      },
      sortChanged(col) {
        if (!col.order) {
          this.condition.sort = "id";
          this.condition.asc = false;
        } else {
          this.condition.sort = col.prop;
          this.condition.asc = col.order == "ascending";
        }
        this.page();
      },
      filterChanged(options) {
        Object.assign(this.condition, options);
        this.page();
      },
    },
  };
</script>

<style scoped></style>
